import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  AppointmentServiceType,
  PreorderAvailabilityStatus,
} from '@medindex-webapi';
import { RegionsService } from '@shared/services/regions.service';
import { MetaService } from '@shared/services/meta/meta.service';
import { StorageService } from '@shared/core/services/storage.service';
import { HelixRoutes } from '@shared/enums/routes';
import { AddToCartMessages } from '@shared/modules/add-cart-item/const/messages';
import { ItemRepositoryService } from '../../services/item-repository.service';
import { CatalogItemTab } from '../../enums/catalog-item-tab.enum';
import { NavigationMenuService } from '@shared/services/navigation-menu.service';

@Component({
  selector: 'app-catalog-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ItemRepositoryService, RegionsService],
})
export class ItemComponent implements OnInit, OnDestroy {
  constructor(
    public repository: ItemRepositoryService,
    public storage: StorageService,
    private route: ActivatedRoute,
    private metaService: MetaService,
    private navigationMenu: NavigationMenuService
  ) {}

  @ViewChild('scrollElement') scrollElement!: ElementRef;
  AppointmentServiceType = AppointmentServiceType;
  HelixRoutes = HelixRoutes;
  PreorderAvailabilityStatus = PreorderAvailabilityStatus;
  ngUnsubscribe$ = new Subject<void>();
  CatalogItemTab = CatalogItemTab;

  readonly AddToCartMessages = AddToCartMessages;

  isHelixLite$ = this.navigationMenu.isHelixLiteAvailable$;

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((params) => {
        const hxid = (params.id as string) || null;
        if (hxid) {
          this.repository.setHxid(hxid);
        }
      });

    this.repository.description$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((description) => {
        this.metaService.description(description);
      });
  }

  scrollToHelixExpressAd(): void {
    const widthContainer = this.scrollElement.nativeElement.clientWidth;

    this.scrollElement.nativeElement.scrollTo({
      left: widthContainer,
      behavior: 'smooth',
    });
  }

  ngOnDestroy(): void {
    this.repository.clear();
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
